import { render, staticRenderFns } from "./ResultSheets.vue?vue&type=template&id=687a4f2a&scoped=true&"
import script from "./ResultSheets.vue?vue&type=script&lang=js&"
export * from "./ResultSheets.vue?vue&type=script&lang=js&"
import style0 from "./ResultSheets.vue?vue&type=style&index=0&id=687a4f2a&scoped=true&lang=css&"
import style1 from "./ResultSheets.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a4f2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VAvatar,VCard,VCardText,VCardTitle,VCol,VContainer,VIcon,VRow,VSpacer})
